<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs4>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regionsWithAll"
                v-model="selectedRegion"
                item-text="name"
                placeholder="Select Region"
                @change="selectRegion"
              >
              </v-select>
            </v-flex>

            <v-flex text-right>
              <v-btn
                @click="openNewNotificationDialog"
                depressed
                color="primary"
              >
                New Notification
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="pushNotifications"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available"
      >
        <template v-slot:item.actions="{ item }">
          <div style="min-width: 50px">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>

          <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon>
        </template>
        <template v-slot:item.content.attachment="{ item }">
          <div style="min-width: 50px">
            <v-icon
              small
              v-if="
                item.content.attachment ? item.content.attachment !== '' : false
              "
            >
              mdi-paperclip
            </v-icon>
          </div>
        </template>
        <template v-slot:item.entity.title="{ item }">
          <div style="min-width: 100px">
            {{ item.entity.title }}
          </div>
        </template>
        <template v-slot:item.state="{ item }">
          <div style="min-width: 80px">
            {{ item.state }}
          </div>
        </template>
        <template v-slot:item.scheduledAt="{ item }">
          {{ iMoment(item.scheduledAt) }}
        </template>
        <!-- <template v-slot:item.region="{ item }">
          <div>
            {{ item.region.name }}
          </div>
        </template> -->
        <!-- <template v-slot:item.createdAt="{ item }">
          <div style="min-width: 100px">
            {{ iMoment(item.createdAt) }}
          </div>
        </template> -->
      </v-data-table>
    </v-card>
    <!-- <edit-data-stream-dialog
      :selectedRegion="selectedRegion"
      :pinDetail="editedItem"
      :collection="collection"
      ref="editDataStreamDialog"
    /> -->
    <new-notification-dialog
      ref="newNotificationDialog"
      :collection="collection"
    />
    <edit-notification-dialog
      ref="editPushNotificationDialog"
      :collection="collection"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EditNotificationDialog from '../components/EditNotificationDialog.vue';
import NewNotificationDialog from '../components/NewNotificationDialog';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
  components: { NewNotificationDialog, EditNotificationDialog },
  data() {
    return {
      selectedRegion: {},
      collection: 'notificationPipeline',

      search: '',
      dialogDelete: false,
      itemToDelete: {},
      headers: [
        {
          text: 'Message',
          align: 'start',
          sortable: true,
          value: 'data.message',
        },
        { text: 'Region', value: 'data.region.name' },
        // { text: "Font Name", value: "fontName" },

        { text: 'State', value: 'state' },
        { text: 'Scheduled At', value: 'scheduledAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedItem: {},
      editedIndex: -1,
      defaultItem: {},
    };
  },
  computed: {
    ...mapState('$_notification', ['pushNotifications']),
    ...mapState('$_home', ['regions']),
    regionsWithAll() {
      var arr = [];
      arr.push({ name: 'All' });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  created() {
    // this.getPushNotifications({
    //   type: 'notification',
    //   collection: this.collection,
    //   mutation: 'updatePushNotifications',
    // });
    if (this.regions.length === 0) {
      this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    }
  },
  methods: {
    ...mapActions({
      getPushNotifications: '$_notification/getContent',
      getPushNotificationsByRegion: '$_notification/getContentByRegion',
      deletePushNotificationItem: '$_notification/deleteContent',
      getRegions: '$_home/getContent',
    }),
    refresh() {
      this.getPushNotifications({
        type: 'notification',
        collection: this.collection,
        mutation: 'updatePushNotifications',
      });
    },
    selectRegion() {
      console.log('selectedRegion: ', this.selectedRegion);
      if (this.selectedRegion) {
        if (this.selectedRegion.name === 'All') {
          this.getPushNotifications({
            type: 'notification',
            collection: this.collection,
            mutation: 'updatePushNotifications',
          });
        } else {
          this.getPushNotificationsByRegion({
            type: 'notification',
            collection: this.collection,
            mutation: 'updatePushNotifications',
            region: this.selectedRegion,
          });
        }
      }
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    openNewNotificationDialog() {
      this.$refs.newNotificationDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.pushNotifications.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign(
        {},
        this.pushNotifications[this.editedIndex],
      );

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editPushNotificationDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.pushNotifications.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign(
        {},
        this.pushNotifications[this.editedIndex],
      );

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editPushNotificationDialog.toggleDialog(
        this.editedItem,
        'copy',
      );
    },
    deleteItem(item) {
      this.editedIndex = this.pushNotifications.indexOf(item);
      this.itemToDelete = Object.assign(
        {},
        this.pushNotifications[this.editedIndex],
      );
      this.itemToDelete.state = 'deleted';
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deletePushNotificationItem({
        details: this.itemToDelete,
        collection: this.collection,
        type: 'notification',
      }).then(() => {
        this.dialogDelete = false;
        this.getPushNotifications({
          type: 'notification',
          collection: this.collection,
          mutation: 'updatePushNotifications',
        });
      });
    },
  },
};
</script>

<style></style>
